import apiConfig from "../../apiConfig";

export const setDonationSidesStatus = async (at, donationSideId, statusId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Sides/Set_Donation_Side_Status",
		{
			Donation_Side_Id: donationSideId,
			Active_Status_Id: statusId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
